function noHtml (v) {
  return v.replace(/(<([^>]+)>)/ig, '')
}

export default noHtml

export {
  noHtml
}
